import { connect } from 'react-redux';

import { StoreState } from '../../../reducers';
import ButtonSettings from '../../../components/Editor/ButtonSettings';
import { getClientAndResourceIds } from '../utils/helpers';

const mapStateToProps = (state: StoreState) => {
	const {
		galleryInfos: { template: { publicationSettings } },
		editor: { settings: { isDisplayed }, themes },
	} = state;
	const { originalGId: publicationId } = getClientAndResourceIds();

	return {
		publicationId,
		isActive: isDisplayed,
		hasPublicationSettings: !!publicationSettings,
		hasThemes: !!themes,
	};
};


export default connect(mapStateToProps)(ButtonSettings);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/ButtonSettings/index.tsx